import React from "react";
import { Col, FormControl } from "react-bootstrap";
import { FormGroupCustom } from "./FormGroupCustom";
import { InputCustom } from "./input/InputCustom";
import { RadioForm } from "./radio/RadioForm";
import { dataFormType } from "./dataFormType";
import { SelectForm } from "./select/SelectForm";
import Error from "./error/Error";
import TextArea from "./textArea/TextArea";
import { CheckboxForm } from "./checkbox/CheckboxForm";
import { CheckboxSingleForm } from "./checkbox/CheckboxSingleForm";

const getByPath = (obj, path) => {
    if (!path) {
        return undefined;
    }

    return path.split(".").reduce((value, key) => value?.[key], obj);
};

export function FormElement({ ele, formik, changeValue, disabled }) {
    const value = getByPath(formik.values, ele.name);
    const error = getByPath(formik.errors, ele.name);

    return (
        <Col key={ele.name} {...(ele.col || {})}>
            <FormGroupCustom label={ele.label}>
                {ele.type === dataFormType.input && (
                    <InputCustom
                        rightTemplate={ele.rightTemplate}
                        ele={ele}
                        val={value || ""}
                        formik={formik}
                        changeValue={(val) => changeValue ? changeValue(ele.name, val) : formik.setFieldValue(ele.name, val)}
                        disabled={disabled}
                    />
                )}
                {ele.type === dataFormType.radio && (
                    <RadioForm ele={ele} formik={formik} changeValue={changeValue} disabled={disabled}></RadioForm>
                )}
                {ele.type === dataFormType.select && (
                    <SelectForm ele={ele} formik={formik} disabled={disabled}></SelectForm>
                )}
                {ele.type === dataFormType.checkbox && (
                    <CheckboxForm ele={ele} formik={formik} disabled={disabled}></CheckboxForm>
                )}
                {ele.type === dataFormType.checkboxSingle && (
                    <CheckboxSingleForm ele={ele} formik={formik} disabled={disabled}></CheckboxSingleForm>
                )}
                {ele.type === dataFormType.textarea && (
                    <TextArea
                        ele={ele}
                        value={value}
                        formik={formik}
                        disabled={disabled}
                    ></TextArea>
                )}
                {!!formik.submitCount &&
                    !!formik.errors &&
                    error && (
                        <Error>
                            {error}
                        </Error>
                    )}
            </FormGroupCustom>
        </Col>
    );
}
